import React, { Component } from 'react'

export default class extends Component {
  render() {
    return <div className="app-grid-tabs">
      {this.props.children}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/AppGridLayout/AppGridTabs.tsx